<template>
  <div>
    <div class="links">
      <div class="footer_links">
        <router-link :to="{name: 'TermsAndConditions'}">Terms and Conditions</router-link>
        <router-link :to="{name: 'PrivacyPolicy'}">Privacy Policy</router-link>
        <router-link :to="{name: 'ConnectPolicy'}">CC-Connect Policy</router-link>
        <a href="https://public.carriercommunity.com/imprint-impressum/" target="_self">Imprint / Impressum</a>
      </div>
    </div>
    <div class="base d-flex align-items-center justify-content-center">
      <p class="rights">© {{$formatDate.getUTCYear()}} Carrier Community | All rights reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
.links {
  background-color: #E1E1E1c7;
  height: 80px;
}

.footer_links {
  width: 50%;
  margin: 0 auto;
  text-align: center;
  padding-top: 32px;
}
.footer_links > a {
  font-family: Montserrat Medium, Sans-serif;
  font-size: 11px;
  font-weight: 600;
  padding: 13px 20px;
  line-height: 30px;
}
a {
  color: #707070;
}
a:hover {
  text-decoration: none;
  color: #BD9D5F;
}
.base {
  height: 50px;
  background-color: #FFF;
}
.rights {
  font-family: Montserrat Medium, Sans-serif;
  font-size: 12px;
  color: #707070;
  margin: 0;
}

@media (max-width: 630px) {
  .footer_links {
    width: unset !important;
    margin: 0 auto;
    padding-top: 20px;
  }
}
</style>
